import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'view-design'
import {setToken, getToken, canTurnTo} from '@/libs/util'
import config from '@/config'

const {homeName} = config

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
  else next({replace: true, name: 'error_401'}) // 无权限，重定向到401页面
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()
  if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页
    })
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next() // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页
    })
  } else {
    console.log(store.state.user.hasGetInfo)
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next)
    } else {

      store.dispatch('AccountServ_GetSelfInfo',
        {
          extfunc:(commit, params, urlparams)=>{
            let selfInfo = store.getters.get_Account_GetSelfInfoResult
            let roleNames = selfInfo.roles.map(item => {return item.name})
            commit('setAccess', roleNames)
            commit('setAvator', selfInfo.avatarUrl)
            commit('setUserName', selfInfo.name)
            commit('setUserId', selfInfo.id)
            commit('setHasGetInfo', true)
            turnTo(to, store.state.user.access, next)
          }
        }
      ).then(res => {

      }).catch(err =>{
        setToken('')
        next({
          name: 'login'
        })
      })
    }
  }
})

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
